const ELLIPSIS = '...';
const DEFAULT_MAX_LENGTH = 40;

export const truncateMiddle = ({ value, maxLength = DEFAULT_MAX_LENGTH }: { value: string; maxLength?: number }) => {
  if (value.length <= maxLength) {
    return value;
  }

  const ellipsisLength = ELLIPSIS.length;
  const availableCharacters = maxLength - ellipsisLength;

  if (availableCharacters <= 0) {
    return value.slice(0, maxLength);
  }

  const headLength = Math.ceil(availableCharacters / 2);
  const tailLength = Math.floor(availableCharacters / 2);

  const head = value.slice(0, headLength);
  const tail = tailLength === 0 ? '' : value.slice(value.length - tailLength);

  return `${head}${ELLIPSIS}${tail}`;
};

export const truncate = (inp: string, length: number): string =>
  inp.length <= length || inp.length <= 3 ? inp : `${inp.slice(0, length - 3)}...`;
